import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { v4 as uuidv4 } from "uuid";
import { mucThuKhacSinhVienApi } from "../../../api/chung-tu/mucThuKhacSinhVienApi";
import { NotifyHelper } from "../../../helpers/toast";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eMucThuSinhVienActionIds,
  IMucThuSinhVienActionTypes,
  IMucThuSinhVienIdsType,
  IMucThuSinhVienLoadType,
} from "../../action-types/muc-thu/IMucThuSinhVienActionTypes";
import { rootActions } from "../../actions/rootActions";

export function* mucThuSinhVienSaga(): any {
  yield takeEvery(eMucThuSinhVienActionIds.LOAD_KHOAN_THU_START, loadKhoanThu);
  yield takeLatest(eMucThuSinhVienActionIds.THEM_KHOAN_START, themKhoan);
  yield takeLatest(eMucThuSinhVienActionIds.SUA_SO_TIEN_START, suaSoTien);
  yield takeLatest(eMucThuSinhVienActionIds.XOA_KHOAN_START, xoaKhoan);
  yield takeLatest(eMucThuSinhVienActionIds.DUYET_THU_START, duyetThu);
  yield takeLatest(eMucThuSinhVienActionIds.HUY_DUYET_THU_START, huyDuyetThu);
  yield takeLatest(
    eMucThuSinhVienActionIds.HUY_DUYET_VA_GO_START,
    huyDuyetVaGo,
  );
}

function* loadKhoanThu(action: IMucThuSinhVienActionTypes): any {
  const { id, request } = action.payload as IMucThuSinhVienLoadType;
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SelectBySinhVien,
    request,
  );
  if (res.is_success) {
    yield put(
      rootActions.mucThu.mucThuSinhVien.LOAD_KHOAN_THU_SUCCESS({
        id,
        data: res.data ?? [],
      }),
    );
  } else {
    NotifyHelper.Error(res.message ?? "Không lấy được khoản thu của sinh viên");
    yield put(
      rootActions.mucThu.mucThuSinhVien.LOAD_KHOAN_THU_ERROR({
        id,
        data: res.message ?? "Có lỗi",
      }),
    );
  }
}

/** Nạp lại khoản thu của tab sau mỗi thao tác ghi, để lưới luôn khớp dữ liệu thật. */
function* napLai(id: string, request: any) {
  yield put(
    rootActions.mucThu.mucThuSinhVien.LOAD_KHOAN_THU_START({ id, request }),
  );
}

function* themKhoan(action: IMucThuSinhVienActionTypes): any {
  const { id, payloads, request } = action.payload as any;
  const danhSach = (payloads ?? []) as any[];
  if (danhSach.length === 0) return;
  yield put(
    rootActions.mucThu.mucThuSinhVien.CHANGE_DANG_XU_LY({ id, data: true }),
  );
  // Gọi LẦN LƯỢT chứ không song song: cùng một sinh viên, chạy song song dễ chèn nhau
  // khi máy chủ dò trùng rồi mới chèn.
  let thanhCong = 0;
  const loi: string[] = [];
  for (const p of danhSach) {
    const res: IBaseRespone = yield call(mucThuKhacSinhVienApi.Create, p);
    if (res.is_success) thanhCong++;
    else loi.push(res.message ?? "Có lỗi");
  }
  if (thanhCong > 0) {
    NotifyHelper.Success(
      danhSach.length === 1
        ? "Đã thêm khoản thu cho sinh viên"
        : `Đã thêm ${thanhCong}/${danhSach.length} khoản thu cho sinh viên`,
    );
    yield napLai(id, request);
  }
  if (loi.length > 0) NotifyHelper.Error(loi[0]);
  yield put(
    rootActions.mucThu.mucThuSinhVien.CHANGE_DANG_XU_LY({ id, data: false }),
  );
}

function* suaSoTien(action: IMucThuSinhVienActionTypes): any {
  const { id, payload, request } = action.payload as any;
  yield put(
    rootActions.mucThu.mucThuSinhVien.CHANGE_DANG_XU_LY({ id, data: true }),
  );
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.UpdateSoTien,
    payload,
  );
  if (res.is_success) {
    NotifyHelper.Success("Đã cập nhật số tiền");
    yield napLai(id, request);
  } else {
    NotifyHelper.Error(res.message ?? "Không cập nhật được số tiền");
  }
  yield put(
    rootActions.mucThu.mucThuSinhVien.CHANGE_DANG_XU_LY({ id, data: false }),
  );
}

function* xoaKhoan(action: IMucThuSinhVienActionTypes): any {
  const { id, ids, request } = action.payload as IMucThuSinhVienIdsType;
  yield put(
    rootActions.mucThu.mucThuSinhVien.CHANGE_DANG_XU_LY({ id, data: true }),
  );
  const res: IBaseRespone = yield call(mucThuKhacSinhVienApi.Deletes, { ids });
  if (res.is_success) {
    NotifyHelper.Success("Đã gỡ khoản thu khỏi sinh viên");
    yield put(
      rootActions.mucThu.mucThuSinhVien.CHANGE_SELECTED_IDS({ id, data: [] }),
    );
    yield napLai(id, request);
  } else {
    NotifyHelper.Error(res.message ?? "Không gỡ được khoản thu");
  }
  yield put(
    rootActions.mucThu.mucThuSinhVien.CHANGE_DANG_XU_LY({ id, data: false }),
  );
}

function* duyetThu(action: IMucThuSinhVienActionTypes): any {
  const { id, ids, request } = action.payload as IMucThuSinhVienIdsType;
  const process_id = uuidv4();
  yield put(
    rootActions.mucThu.mucThuSinhVien.OPEN_PROCESSING_MODAL(process_id),
  );
  const res: IBaseRespone = yield call(mucThuKhacSinhVienApi.DuyetAsync, {
    process_id,
    payload: ids,
  });
  if (res.is_success) {
    NotifyHelper.Success("Đã duyệt thu các khoản đã chọn");
    yield napLai(id, request);
  } else {
    NotifyHelper.Error(res.message ?? "Không duyệt thu được");
  }
}

function* huyDuyetThu(action: IMucThuSinhVienActionTypes): any {
  const { id, ids, request } = action.payload as IMucThuSinhVienIdsType;
  const process_id = uuidv4();
  yield put(
    rootActions.mucThu.mucThuSinhVien.OPEN_PROCESSING_MODAL(process_id),
  );
  const res: IBaseRespone = yield call(mucThuKhacSinhVienApi.HuyDuyetAsync, {
    process_id,
    payload: ids,
  });
  if (res.is_success) {
    NotifyHelper.Success("Đã hủy duyệt các khoản đã chọn");
    yield napLai(id, request);
  } else {
    NotifyHelper.Error(res.message ?? "Không hủy duyệt được");
  }
}

/**
 * Hủy duyệt rồi gỡ luôn: khoản ĐÃ duyệt thu không xóa thẳng được (máy chủ chặn), nên phải
 * bỏ duyệt trước — gộp hai bước vào một thao tác để người dùng không phải làm hai lần.
 */
function* huyDuyetVaGo(action: IMucThuSinhVienActionTypes): any {
  const { id, ids, request } = action.payload as IMucThuSinhVienIdsType;
  const process_id = uuidv4();
  yield put(
    rootActions.mucThu.mucThuSinhVien.OPEN_PROCESSING_MODAL(process_id),
  );
  const huy: IBaseRespone = yield call(mucThuKhacSinhVienApi.HuyDuyetAsync, {
    process_id,
    payload: ids,
  });
  if (!huy.is_success) {
    NotifyHelper.Error(huy.message ?? "Không hủy duyệt được");
    return;
  }
  const go: IBaseRespone = yield call(mucThuKhacSinhVienApi.Deletes, { ids });
  if (go.is_success) {
    NotifyHelper.Success("Đã hủy duyệt và gỡ khoản khỏi sinh viên");
    yield put(
      rootActions.mucThu.mucThuSinhVien.CHANGE_SELECTED_IDS({ id, data: [] }),
    );
  } else {
    NotifyHelper.Error(
      go.message ?? "Đã hủy duyệt nhưng chưa gỡ được khoản",
    );
  }
  yield napLai(id, request);
}
